import { FormDefaultAttributes, type DatePickerConfig } from '@common';

export const SOURCE_LAYER_FORM_CONFIG = {
  name: 'sourceLayerForm',
  attributes: {
    ...FormDefaultAttributes.getFormDefaultAttributes()
  },
  children: [
    {
      name: 'sourceLayer',
      component: 'select',
      attributes: {
        label: 'statistics.wizard.label.sourceLayer',
        itemTitle: 'name',
        hideDetails: true
      },
      settings: {
        needTranslate: true,
        grid: {
          cols: 12,
          md: 12
        }
      }
    } as DatePickerConfig
  ]
};
